import { api } from "../client";
import {
  DocumentSerieDefinitionExtraFields,
  DocumentSerieDefinitionFields,
  PartialDocumentSerieDefinitionExtraFields,
  PartialDocumentSerieDefinitionFields,
} from "../schema/DocumentSerieDefinition";
import { Config, ConfigMutate } from "../types";

type ApiRequestConfig = Config<
  DocumentSerieDefinitionFields,
  DocumentSerieDefinitionExtraFields
>;
type ApiRequestConfigMutate = ConfigMutate<
  PartialDocumentSerieDefinitionFields,
  PartialDocumentSerieDefinitionExtraFields
>;

export const getDocumentSeriesDefinitions = async (
  config?: ApiRequestConfig
) => {
  return api.get<
    DocumentSerieDefinitionFields,
    DocumentSerieDefinitionExtraFields
  >("document_series_definitions", config);
};
export const getDocumentSeriesDefinition = (
  id: number,
  config?: ApiRequestConfig
) => {
  return api.get<
    DocumentSerieDefinitionFields,
    DocumentSerieDefinitionExtraFields
  >(`document_series_definitions/${id}`, config);
};

export const createDocumentSeriesDefinition = (
  config: ApiRequestConfigMutate
) => {
  return api.create<
    PartialDocumentSerieDefinitionFields,
    PartialDocumentSerieDefinitionExtraFields
  >("document_series_definitions", config);
};
export const updateDocumentSeriesDefinition = (
  id: number,
  config?: ApiRequestConfigMutate
) => {
  return api.update<
    PartialDocumentSerieDefinitionFields,
    PartialDocumentSerieDefinitionExtraFields
  >(`document_series_definitions/${id}`, config);
};
export const deleteDocumentSeriesDefinition = (id: number) => {
  return api.remove<
    DocumentSerieDefinitionFields,
    DocumentSerieDefinitionExtraFields
  >(`document_series_definitions/${id}`);
};
